// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/ChampionshipSelectField.tsx
import { FunctionComponent } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SelectField } from '@/components/SelectField';
import { useChampionships } from '@/services/queries/championship';
import { SeasonFormData } from '../../schemas';

const PREFIX = 'pages.application_season.components.season_step1.fields.championship';

type ChampionshipSelectFieldProps = {
  /**
   * Quando true, renderiza o campeonato como label não-editável (fluxo de Edit).
   * Mudar `championship_uuid` de uma Season existente é destrutivo.
   */
  readOnly?: boolean;
};

export const ChampionshipSelectField: FunctionComponent<ChampionshipSelectFieldProps> = ({
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const { data } = useChampionships();
  const championships = data?.data ?? [];

  const selectedUuid = watch('championship_uuid');
  const selectedName =
    championships.find(item => item.uuid === selectedUuid)?.name ?? '';

  if (readOnly) {
    return (
      <Box>
        <Text fontWeight="medium" mb={1}>
          {t(`${PREFIX}.label`)}
        </Text>
        <Text fontSize="16px" color="text.main" fontWeight="semibold">
          {selectedName || '-'}
        </Text>
      </Box>
    );
  }

  return (
    <Box>
      <Text fontWeight="medium" mb={1}>
        {t(`${PREFIX}.label`)}
      </Text>
      <SelectField
        {...register('championship_uuid')}
        rootProps={{
          isInvalid: !!errors.championship_uuid,
          errorMessage: errors.championship_uuid?.message,
        }}
      >
        <option value="" disabled>
          {t(`${PREFIX}.placeholder`)}
        </option>
        {championships.map(championship => (
          <option key={championship.uuid} value={championship.uuid}>
            {championship.name}
          </option>
        ))}
      </SelectField>
      <Text fontSize="13px" color="gray.500" mt={1}>
        {t(`${PREFIX}.help`)}
      </Text>
    </Box>
  );
};
